<div
  class="drawer"
  [class.drawer-overlap]="openedStateMode === 'overlap'"
  [class.drawer-opened]="menuOpened"
>
  <aside
    id="app-sidebar"
    class="drawer-panel"
    [attr.aria-label]="'common.nav.sidebar' | translate"
  >
    <div class="side">
      <ng-content select="[slot=side]"></ng-content>
    </div>
    @if (openedStateMode === 'shrink') {
      <button
        type="button"
        class="sidebar-toggle"
        aria-controls="app-sidebar"
        [attr.aria-expanded]="menuOpened"
        [attr.aria-label]="
          (menuOpened ? 'common.nav.collapse' : 'common.nav.expand') | translate
        "
        [title]="
          (menuOpened ? 'common.nav.collapse' : 'common.nav.expand') | translate
        "
        (click)="toggleMenu()"
      >
        <i
          class="app-icon fa-solid"
          [ngClass]="menuOpened ? 'fa-angles-left' : 'fa-angles-right'"
        ></i>
      </button>
    }
  </aside>
  @if (openedStateMode === 'overlap' && menuOpened) {
    <!-- The backdrop closes the drawer; Escape and the menu button do so for the keyboard. -->
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <div class="drawer-backdrop" (click)="onContentClick()"></div>
  }
  <div class="main-column">
    <ng-content select="[slot=header]"></ng-content>
    <!-- A click on the content closes the side menu on small screens; it has its own toggle button. -->
    <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
    <section class="main" (click)="onContentClick()">
      @if (loading) {
        <app-load-panel [showElapsed]="loadingElapsed"></app-load-panel>
      }
      <div class="main-scroll">
        <div class="main-scroll-content">
          <ng-content></ng-content>
          <ng-content select="[slot=footer]"></ng-content>
        </div>
      </div>
    </section>
  </div>
</div>
